import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerUserIdAtom} from "./routerStore";
import {User} from "../types/domain/user";
import {getUserById} from "../services/userService";

/**
 * Retrieving Active User for Id retrieved from URL
 */
export const activeUserAtom = atomWithRefresh<Promise<User | undefined>>(async (get) => {
    const activeUserId = get(routerUserIdAtom);

    return activeUserId !== undefined ? await getUserById(activeUserId) : undefined;
});

export const activeUserLoadable = loadable(activeUserAtom);
